import { Button, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import CustomTable from "../../../components/common/CustomTable";
import IconButton from "../../../components/common/IconButton";
import Subheader from "../../../components/ui/Subheader";
import { addKeyInArray, pathLink } from "../../../helpers/siteConfig";
import useTable from "../../../hooks/useTable";
import AdminLayout from "../../../layouts/AdminLayout";
import {
  getAllAreaAsync,
  getCountAreaAsync,
} from "../../../store/features/NP/geoInfo/geoAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { CommonParams, GetAreaData, TableData } from "../../../types/redux";
import { AddZero, countRow } from "../../../utils/number";
import { capitalize } from "lodash";

export default function Area() {
  const dispatch = useAppDispatch();
  const { limit, page, handlePagination } = useTable();
  const { areas, loading, areaCount } = useAppSelector((state) => state.npGeo);
  const location = useLocation();
  const path = pathLink(location.pathname, 1);

  const columns: ColumnsType<TableData<GetAreaData>> = [
    {
      title: "No.",
      align: "center",
      width: 120,
      render: (_, __, idx) => countRow(page, limit, idx),
    },
    {
      title: "Zonal Name",
      dataIndex: "areaName",
      render: (val: string) => {
        const capitalizeText = (text: string) =>
          text?.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

        return <div>{val ? capitalizeText(val) : "N/A"}</div>;
      },
    },

    {
      title: "Cluster Name",
      render: (val: GetAreaData) => {
        const capitalizeText = (text: string) =>
          text?.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

        return (
          <div>
            {val?.region?.regionName
              ? capitalizeText(val.region.regionName)
              : "N/A"}
          </div>
        );
      },
    },

    {
      title: "Action",
      align: "center",
      render: (val: GetAreaData) => (
        <Link to={`/${path}/geo-info/area/update-area/${val?._id}`}>
          <Button icon={<EditIcon />} />
        </Link>
      ),
    },
  ];

  useEffect(() => {
    const params: CommonParams = {
      limit: limit,
      skip: limit * (page - 1),
    };

    dispatch(
      getAllAreaAsync({
        params,
      })
    );
  }, [dispatch, limit, page]);

  useEffect(() => {
    dispatch(getCountAreaAsync());
  }, [dispatch]);

  return (
    <AdminLayout title="Zonal List" headerTitle="Geo Informations">
      <section className="mt-7">
        <Subheader
          title="Zonal List"
          subTitle={`Total Zonal: ${AddZero(areaCount)}`}
        >
          <Space size="middle">
            <Link to={`/${path}/geo-info/area/add-area`}>
              <IconButton type="primary" nextIcon={<AddIcon />}>
                Add Zonal
              </IconButton>
            </Link>
          </Space>
        </Subheader>
      </section>

      <CustomTable<TableData<GetAreaData>>
        loading={loading}
        total={areaCount}
        page={page}
        handlePagination={handlePagination}
        columns={columns}
        dataList={addKeyInArray(areas)}
        bordered={false}
      />
    </AdminLayout>
  );
}
